import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsEmployee from "graphql/fields/FieldsEmployee";

const fields = {
	'guid': 'String',
	'external_id': 'String',
	'name': 'String',
	'email': 'String',
	'phonenumber': 'String',
	'landline_phonenumber': 'String',
	'visible_for_employees': 'String',
	'license_plate': 'String',
	'transport_kind': 'String',
	'address_postal_code': 'String',
	'access_card_id': 'String',
	'verified': 'String',
	'active': 'String',
	'response_employee': 'String',
	'confidant': 'String',
	'company_guid': 'String',
	'department_guid': 'String',
	'team_guid': 'String',
	'jobtitle_guid': 'String',
	'gdpr': 'String',
	'show_favourite': 'String',
	'show_phonenumber': 'String',
	'show_calendar': 'String',
	'can_scan_presence_qr_code': 'String',
};

// Note management is made to ensure that the editing of your on profile still works in the app
export default gql(`
	mutation management_employee( ${ HelperGraphql.createFields( fields ) } ) {
	    management_employee( ${ HelperGraphql.createVariables( fields ) } ) {
	       ${FieldsEmployee}
	       external_id
		   verified
			
	       user {
				guid
				active
				kind
				
				rights{
					user_right
					active
				}
			}
	       
	       team {
				guid
			}
			
			department {
				guid
			}
			
			jobtitle {
				guid
			}
	    }
	}
`);

